export const IntentsDisplayNamesWithContentItems = ["General Question", "Latest Messages", "Yes", "No", "Number", "Stop", "Help"]; 
export const IntentVoicifyNamesWithContentItems = ["GeneralQuestion", "WhatsNew", "Yes", "No", "Stop", "Number", "Help"];
